export default __webpack_public_path__ + "static/media/selected-plan-icon.a9d7c81f.svg";